import React from "react";
import { useNotification } from "GlobalStore/notification";
import { updateNotificationStatus } from "Helpers/fetch";
import Cookie from "js-cookie";
import { setDataLayer } from "Helpers/utils";
import { Mobile } from "./Mobile";
import { Desktop } from "./Desktop";

export const Notification = (props) => {

	const data = useNotification((state) => state.data);

	const handleOnClose = (id) => {

		useNotification?.getState()?.removeNotification(id);

	};

	const seenNotif = (params) => {

		const auth = Cookie.get("token");

		const dataLayerObj = {
			event: "click_push_notification",
			username: Cookie.get("usrname"),
			category_notif: params?.category_notif,
			subcategory_notif: params?.subcategory_notif,
			type_notif: params?.type_notif,
		};
		setDataLayer(dataLayerObj, "GTM");
		if (auth) {

			updateNotificationStatus({
				method: "POST",
				Authorization: Cookie.get("token"),
				data: {
					id: params.notifId,
					is_read_from: "push_notification",
				},
			}).then((res) => {

				if (res.data.meta.code === 200) {

					window.location.href = params.url;

				}
				return null; // Jika response tidak sesuai

			}).catch((error) => {

				console.error(error);

			});

		}

	};

	if (data.length < 1) return null;

	if (props.isMobile) {

		return (
			<Mobile
				data={data}
				onClose={handleOnClose}
				seenNotif={seenNotif}
			/>
		);

	}
	return (
		<Desktop
			data={data}
			onClose={handleOnClose}
			seenNotif={seenNotif}
		/>
	);

};

export default Notification;
